export const contactsEndpoints = {
  getInternalContacts: { method: 'get', path: '/get/{supplierId}/internal' },
  insertInternalContact: { method: 'post', path: '/insert/internal' },
  updateInternalContact: { method: 'post', path: '/update/{id}/internal' },
  deleteInternalContact: { method: 'post', path: '/delete/internal' },
  getExternalContacts: { method: 'get', path: '/get/{supplierId}/external' },
  insertExternalContact: { method: 'post', path: '/insert/external' },
  updateExternalContact: { method: 'post', path: '/update/{id}/external' },
  deleteExternalContact: { method: 'post', path: '/delete/external' },
  setPrimaryExternalContact: { method: 'post', path: '/set-primary/external' },
} as const
